/**
 * Format cart/order lines for WhatsApp (e.g. "1 x Product Name  -").
 * @param {Array<{ product?: string, name?: string, quantity?: number }>} items
 */
export function formatOrderedItemsForWhatsApp(items) {
  if (!items?.length) return ''
  return items
    .map((item) => {
      const q = Number(item.quantity)
      const qty = Number.isFinite(q) && q > 0 ? q : 1
      const name = String(item.product || item.name || 'Product').trim()
      return `${qty} x ${name}  -`
    })
    .join('\n')
}
